var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{class:this.class,style:(_vm.style),attrs:{"align-h":_vm.alignH,"align-v":_vm.alignV}},[_c('MotorS',{attrs:{"cp":this.cp,"childrens":this.childrens,"idTela":_vm.idTela}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }